import { faArrowRight } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@realtyka/real-ui';
import React, { useState } from 'react';
import InstructionCard from '../../../components/InstructionCard';
import NotificationMessage from '../../../components/NotificationMessage';
import useDeviceType from '../../../hooks/useDeviceType';
import { IdentitySummaryResponseMfaTypeEnum } from '../../../openapi/keymaker';

interface MfaMethodSelectCardProps {
  onContinue: (selectedMFAMethod: IdentitySummaryResponseMfaTypeEnum) => void;
}

const MfaMethodSelectCard: React.FC<MfaMethodSelectCardProps> = ({
  onContinue,
}) => {
  const [selectedMFAMethod, setSelectedMFAMethod] =
    useState<IdentitySummaryResponseMfaTypeEnum>();
  const { isMobile } = useDeviceType();

  return (
    <div className='mt-2'>
      <NotificationMessage message='This can be changed anytime by deleting the active method.' />
      <div className='flex flex-col gap-y-2 my-6'>
        <InstructionCard
          title='Text Messages (SMS)'
          instructions={
            <React.Fragment>
              Receive a confirmation code via text messages.
              <br />
              📱 You will need to provide your phone number.
              <br />
              📶 You will need cellular service to receive the messages.
            </React.Fragment>
          }
          isSelected={
            selectedMFAMethod === IdentitySummaryResponseMfaTypeEnum.Sms
          }
          onClick={() =>
            setSelectedMFAMethod(IdentitySummaryResponseMfaTypeEnum.Sms)
          }
        />
        <InstructionCard
          title='Authenticator App'
          instructions={
            <React.Fragment>
              Get verification codes from an app even offline.
              <br />
              📱 Requires installing an authenticator app on your phone
              <br />
              👍 Access Rezen even without cellular connection.
            </React.Fragment>
          }
          isSelected={
            selectedMFAMethod ===
            IdentitySummaryResponseMfaTypeEnum.Authenticator
          }
          onClick={() =>
            setSelectedMFAMethod(
              IdentitySummaryResponseMfaTypeEnum.Authenticator,
            )
          }
        />
      </div>
      <div className='flex flex-col w-full mb-2'>
        <Button
          variant='filled'
          size={isMobile ? 'sm' : 'md'}
          type='submit'
          fullWidth
          color='primary'
          disabled={!selectedMFAMethod}
          onClick={() => onContinue(selectedMFAMethod!)}
        >
          <div className='flex items-center gap-1.5'>
            <div className='font-medium'>Continue</div>
            <FontAwesomeIcon icon={faArrowRight} />
          </div>
        </Button>
      </div>
    </div>
  );
};

export default MfaMethodSelectCard;
